<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'connect-perangkat'">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Hubungkan Perangkat" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 vh-100 d-grid-12">
                    <div class="p-x-20 grid-cspan-12" style="min-height: 50vh;">
                        <div class="m-d-20">
                            <label class="m-d-0">
                                Apakah Whatsapp {{ getNomor }} berada di perangkat yang Anda gunakan ini?
                            </label>
                        </div>
                        <div class="separator-line m-d-20"></div>
                        <div class="options d-flex m-d-20" @click="onSelect(2)">
                            <div class="m-r-8">
                                <IconBased width="16" height="16" v-if="selected === 2">
                                    <template v-slot:icons>
                                        <RadioCheckedBlue />
                                    </template>
                                </IconBased>
                                <IconBased width="16" height="16" v-else>
                                    <template v-slot:icons>
                                        <RadioUnChecked />
                                    </template>
                                </IconBased>
                            </div>
                            <div>
                                <div class="title">
                                    <label class="m-d-0">Tidak</label>
                                </div>
                                <div class="sub-title">
                                    <label class="m-d-0">Whatsapp tersebut berada di perangkat lain.</label>
                                </div>
                            </div>
                        </div>
                        <div class="separator-line m-d-20"></div>
                        <div class="options d-flex m-d-20" @click="onSelect(1)">
                            <div class="m-r-8">
                                <IconBased width="16" height="16" v-if="selected === 1">
                                    <template v-slot:icons>
                                        <RadioCheckedBlue />
                                    </template>
                                </IconBased>
                                <IconBased width="16" height="16" v-else>
                                    <template v-slot:icons>
                                        <RadioUnChecked />
                                    </template>
                                </IconBased>
                            </div>
                            <div>
                                <div class="title">
                                    <label class="m-d-0">Ya, Benar</label>
                                </div>
                                <div class="sub-title">
                                    <label class="m-d-0">Whatsapp tersebut ada di perangkat ini.</label>
                                </div>
                            </div>
                        </div>
                        <div class="separator-line m-d-20"></div>

                    </div>
                    <div class="p-x-20 grid-cspan-12">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Berikutnya'"
                            :id="`wa-autosender-btn-con-perangkat`"
                            :disable="!selected || !getNomor"
                            @action="nextStep"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import IconBased from "../../components/iconPack/IconBased.vue";
import RadioUnChecked from "../../components/iconPack/RadioUnChecked1616.vue";
import RadioCheckedBlue from "../../components/iconPack/RadioCheckedBlue1616.vue";

import { moduleName } from "../../store/state";

export default {
    name: "WaConnectIndex",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        IconBased,
        RadioCheckedBlue,
        RadioUnChecked,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.register.confirm") {
                vm.$toast.success("Berhasil melakukan pembayaran.");
            }

            if (from.name === "wa_autosender.daftar_perangkat" || from.name === "wa_autosender.detail_perangkat") {
                vm.setBackLink(from.name);
            }

            if (from.name === "wa_autosender.detail_perangkat.ubah_nomor") {
                vm.setBackLink("wa_autosender.detail_perangkat");
            }
        });
    },
    data() {
        return {
            selected: this.$route.query.onsite,
            backLink: "wa_autosender.daftar_perangkat",
        };
    },
    mounted() {
        this.init();
        this.smartTrackingView("scan_perangkat_whatsapp");

    },
    computed: {
        ...mapGetters(moduleName, {
            dataDeviceTiny: "dataDeviceTiny",
        }),
        getNomor() {
            return `+${this.dataDeviceTiny.country_code}${this.dataDeviceTiny.number}`;
        },
    },
    methods: {
        ...mapActions({
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            setQr: `${moduleName}/setQr`,
        }),
        back() {
            this.$router.push({ name: this.backLink });
        },
        init() {
            if (this.$route.params.id_device) {
                this.getDetailTinyDevice({ id_mesin: this.$route.params.id_device });
            }
        },
        onSelect(val) {
            this.selected = val;
        },
        setBackLink(val) {
            this.backLink = val;
        },
        nextStep() {
            let query = {
                onsite: this.selected,
            };

            if (this.selected === 1) {
                this.$router.push({ name: "wa_autosender.connect_perangkat.on_site", query });
                this.smartTrackingClick("scan_lain_perangkat_whatsapp");
            } else {
                this.setQr("");
                this.$router.push({ name: "wa_autosender.connect_perangkat.off_site", query });
                this.smartTrackingClick("scan_ini_perangkat_whatsapp");
            }
        },
    },
};
</script>
<style scoped>
.separator-line {
    margin-left: -20px;
    margin-right: -20px;
}
</style>
